import React from "react";
import { List, ListItem, ListItemText, ListItemIcon, Typography, } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "../MenuIcon";
import { navigationRoutes } from "../../models/navigationRoutes";
const AdminMenu = ({ toolbarColor, isAdmin, altToolbarColor, fontSize, headerFontSize, open }) => {
    const location = useLocation();
    const filteredRoutes = navigationRoutes.filter((route) => {
        if (route.MenuID === 5 && isAdmin && location.pathname.includes("/admin/"))
            return true;
        // allow the menu if not in /admin/ and the user is an admin and ID == 9
        if (route.ID === "9" && isAdmin && !location.pathname.includes("/admin/"))
            return true;
        if (route.ID === "2" && location.pathname !== "/")
            return true;
        return false;
    });
    return (React.createElement(React.Fragment, null,
        filteredRoutes.map((route, index) => index === 0 && (React.createElement(Typography, { key: "admin-0", component: "h5", sx: { margin: "0px 0px 5px 15px", color: toolbarColor, fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "inherit" } }, "Administration"))),
        React.createElement(List, { key: "admin-1" }, filteredRoutes.map((route) => (React.createElement(React.Fragment, { key: route.ID },
            React.createElement(ListItem, { key: route.ID, "data-key": route.ID, component: Link, to: route.NavigationDestination },
                React.createElement(ListItemIcon, { sx: {
                        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "inherit",
                        color: location.pathname === route.NavigationDestination
                            ? toolbarColor
                            : altToolbarColor !== null && altToolbarColor !== void 0 ? altToolbarColor : toolbarColor,
                    } },
                    React.createElement(MenuIcon, { iconName: route.Icon })),
                React.createElement(ListItemText, { primary: route.DisplayName, sx: {
                        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "inherit",
                        color: location.pathname === route.NavigationDestination
                            ? toolbarColor
                            : altToolbarColor !== null && altToolbarColor !== void 0 ? altToolbarColor : toolbarColor,
                    } }))))))));
};
export default AdminMenu;
